/**
 * Custom editor layout script class
 *
 * @package    Components
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';

export default class CustomEditor extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
        modules: PropTypes.object,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        withLabel: false,
        onBlurSkip: false,
        modules: {
            toolbar: [
                [{ header: [1, 2, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                ['clean'],
                ['link']
            ],
        },
    };

    render() {
        const {
            onChange,
            onBlur,
            modules,
            ...input
        } = this.props;

        return (
            <ReactQuill
                {...input}
                modules={modules}
                onChange={(newValue, delta, source) => {
                    if (source === 'user') {
                        onChange(newValue);
                    }
                }}
                onBlur={(range, source, quill) => {
                    onBlur(quill.getHTML());
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/CustomEditor/CustomEditor.jsx